import { Routes, UrlMatcher } from '@angular/router';
import { HomePage } from './home/home.page';
import { ShopPage } from './shop/shop.page';

/** Routes root-level public shop URLs without changing their query-string format. */
const commerceStorefrontMatcher: UrlMatcher = (segments) => {
  const hasStorefrontId = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('storefrontId');
  return hasStorefrontId ? { consumed: segments } : null;
};

export const routes: Routes = [
  {
    matcher: commerceStorefrontMatcher,
    component: ShopPage
  },
  {
    path: 'home',
    component: HomePage
  },
  {
    path: '',
    component: HomePage
  },
  {
    path: '**',
    component: HomePage
  },
];
